import { Injectable } from '@angular/core';
import {
    AgingTrendMetricRequest,
    AgingTrendMetricSummaryRequest,
    ArSnapshotControllerService,
} from '@core/generated/openapi';
import { HttpCache } from 'rcp-common-lib';
import {
    CACHE_KEYS,
    CACHE_TIMEOUT_DEFAULT,
} from '@core/constants/cache-keys.constants';

@Injectable({
    providedIn: 'root',
})
export class ArSnapshotService {
    constructor(
        private arSnapshotControllerService: ArSnapshotControllerService,
    ) {}

    @HttpCache(
        CACHE_KEYS.AR_SNAPSHOT.findARSnapshotAgingTrendMetrics,
        CACHE_TIMEOUT_DEFAULT,
    )
    findARSnapshotAgingTrendMetrics(request: AgingTrendMetricRequest) {
        return this.arSnapshotControllerService.findARSnapshotAgingTrendMetrics(
            request,
        );
    }

    @HttpCache(
        CACHE_KEYS.AR_SNAPSHOT.findARSnapshotAgingTrendMetricSummary,
        CACHE_TIMEOUT_DEFAULT,
    )
    findARSnapshotAgingTrendMetricSummary(
        request: AgingTrendMetricSummaryRequest,
    ) {
        return this.arSnapshotControllerService.findARSnapshotAgingTrendMetricSummary(
            request,
        );
    }
}
